import { defineMessages } from 'react-intl';


const MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES = defineMessages({
    MAGIC_LINK_SIGN_IN_TITLE: {
        id: 'web-components.mtg-calculator.sign-in-screen.title',
        defaultMessage: 'Save your calculator results',
    },
    MAGIC_LINK_SIGN_IN_CTA: {
        id: 'web-components.mtg-calculator.sign-in-screen.cta',
        defaultMessage: 'Save results',
    },
    EMAIL_LABEL: {
        id: 'web-components.mtg-calculator.sign-in-screen.email-label',
        defaultMessage: 'Email address',
    },
    EMAIL_PLACEHOLDER: {
        id: 'web-components.mtg-calculator.sign-in-screen.email-placeholder',
        defaultMessage: 'Enter your email',
    },
    DESCRIPTION: {
        id: 'web-components.mtg-calculator.sign-in-screen.description-text',
        defaultMessage: 'Enter your email and we\'ll pre-fill your details into our calculator next time you visit.',
    },
    NEWSLETTER_SUBSCRIPTION_LABEL: {
        id: 'web-components.mtg-calculator.sign-in-screen.newsletter-subscription-label',
        defaultMessage: 'Join our newsletter to receive regular updates on mortgage rates!',
    },
});

export default MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES;
